import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

import { cn } from "src/lib/utils";
import { Button } from "src/Components/ui/button";
import { Calendar } from "src/Components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/Components/ui/popover";
import { useController } from "react-hook-form";
import { useTranslation  } from "react-i18next";
import { indexStore } from "src/store/indexStore";
export function DatePickerForm({ name, control }) {

  const { t } = useTranslation();
  const { lang } = indexStore();
  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields },
  } = useController({
    name,
    control,
    // defaultValue: , // Set an empty array as the default value
  });
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          dir={lang === "ar" ? "rtl" : "ltr"}
          className={cn(
            "w-full justify-start text-left font-normal",
            !field.value && "text-muted-foreground"
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {field.value ? format(field.value, "PPP") : <span>{t("gloabl.pick_a_date")}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
            selected={field.value}
          onSelect={field.onChange}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
